let stropheConnection = require("./stropheConnection.js");
let utils = require("./utils.js");
let grpConversation = require("./conversation.js");
let storage = require("./storage.js");
const contact = require("./contact.js");
const indexDb = require("./indexDb.js");
let language = require('./locale/language.js');
let mediaUrl = window._env_.ApiURL + "/media/";
const webEncrypt  = require('./webchatEncryptDecrypt.js');

let colorCode = "";

module.exports = {

  getGroups: function () {
    let groupiq = stropheConnection.StropheJs().$iq({
      type: "get",
      to: "any@mix." + stropheConnection.Server(),
      id: utils.randomString(16, "a#")
    }).c("query", {
      xmlns: "jabber:iq:mixgroupchat",
      status: "get_group_id"
    });
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().sendIQ(groupiq, module.exports.groupiqCallback);
    }
    // Indicate that this handler should be called repeatedly
  },
  getGroup: function (groupId) {
    let groupiq = stropheConnection.StropheJs().$iq({
      type: "get",
      to: groupId + "@mix." + stropheConnection.Server(),
      id: utils.randomString(16, "a#")
    }).c("query", {
      xmlns: "jabber:iq:mixgroupchat",
      status: "get_group_profile",
      group_id: groupId
    });
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().sendIQ(groupiq, module.exports.groupiqCallback);
    }
    // Indicate that this handler should be called repeatedly
  },
  groupiqCallbackProfileGet: function(){
    let groupProfile = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
    if (groupProfile == null) {
      groupProfile = {};
    }
    return groupProfile;
  },
  groupIqCallBackImageEmptyCheck: function(image){
    if (image == "" || image == "empty") {
      image = "src/images/avatar/group/group_four.svg";
    }
    return image;
  },
  groupiqCallbackProfileUpdate: function(groupProfile,nodeJid,groupIQVal,Createddate){
    let nickName,image,specialGroup,notificationGroup,siteId,icon,foregroundColor,locationId;

    if (groupIQVal.find("vCard").length) {
      nickName = groupIQVal.find("vCard").find("nickName").text();
       groupProfile[nodeJid].push(nickName);
       image = groupIQVal.find("vCard").find("image").text().trim();
       image = module.exports.groupIqCallBackImageEmptyCheck(image);
       
       groupProfile[nodeJid].push(image);
       groupProfile[nodeJid].push(Createddate);
       specialGroup = groupIQVal.find("vCard").find("specialGroup").text();
       notificationGroup = groupIQVal.find("vCard").find("notification").text();
       siteId = groupIQVal.find("vCard").find("locationId").text();
       icon = groupIQVal.find("vCard").find("icon").text();
       foregroundColor = groupIQVal.find("vCard").find("foregroundColor").text();
       locationId = groupIQVal.find("vCard").find("locationId").text();
       if (specialGroup)
         groupProfile[nodeJid].push(specialGroup);
       if (notificationGroup)
         groupProfile[nodeJid].push(notificationGroup);
       if (siteId)
         groupProfile[nodeJid].push(siteId);
       if(icon)
         groupProfile[nodeJid].push(icon);
       if(foregroundColor)
         groupProfile[nodeJid].push(foregroundColor);
       if(locationId)
         groupProfile[nodeJid].push(locationId);
     }

     let groupObj = {
      groupProfile : groupProfile,
      image : image,
      icon  : icon,
      foregroundColor : foregroundColor,
      locationId  : locationId
     }

     return groupObj;
  },
  groupiqCallbackProfileImage(image){
    let profileImage;
    let mediaUrl = window._env_.ApiURL + "/media/";
    let userToken = storage.getuserToken();

    if (utils.getHexRegexPattern().test(image)) {
      profileImage = image;
    } else if (image !== "src/images/avatar/group/group_four.svg" && image.trim() !== "") {
      profileImage = mediaUrl + image + "?mf=" + userToken;
    } else if (image.trim() == "") {
      profileImage = "src/images/avatar/group/group_four.svg";
    } else {
      profileImage = image;
    }
    return profileImage;
  },
  groupIqCallbackProfessionAppend: function(locationId,nodeJid){
    if(utils.getSiteAbbreviation(locationId)){
      $("[id='"+nodeJid+"']").find(".profession").show()
      $("[id='"+nodeJid+"']").find(".profession").html(utils.getSiteAbbreviation(locationId));
    }else {
      $("[id='"+nodeJid+"']").find(".profession").html(utils.getSiteAbbreviation(locationId));
      $("[id='"+nodeJid+"']").find(".profession").hide()
    }
  },
  getGroupIqOncallIcon: function(icon){
    icon = (typeof(icon) != 'undefined') ? icon:"";

    return icon;
  },
  getGroupIqForegroundColor: function(foregroundColor){
    let fillColor = (typeof(foregroundColor) != 'undefined') ? foregroundColor:"#fff";

    return fillColor;
  },
  groupiqCallbackIconUpdate(nodeJid,nickName,locationId,image,iconObj,profileImage){
    let icon = iconObj.icon;
    let foregroundColor = iconObj.foregroundColor;

    if ($("[id='"+nodeJid+"']").length) {
      $("[id='"+nodeJid+"']").find(".name-meta").prop("title", minEmoji(nickName));
      $("[id='"+nodeJid+"']").find(".name-meta").html(minEmoji(nickName));
      
      module.exports.groupIqCallbackProfessionAppend(locationId,nodeJid);
      
      $("[id='forwardcontact-"+nodeJid+"']").find(".name-meta").html(minEmoji(nickName));
      let Icon ='';
      if (utils.getHexRegexPattern().test(image) || image.startsWith("#")) {
        let onCallImage = image;
        let onCallIcon = module.exports.getGroupIqOncallIcon(icon);
        let fillColor = module.exports.getGroupIqForegroundColor(foregroundColor);

        Icon = utils.getOncallIcon(onCallIcon, fillColor, onCallImage);
        
        let imageRGB = utils.hexToRgbA(profileImage);
        $("[id='"+nodeJid+"']").find(".other-prof-pic").remove();
        let imgDiv = '<div class="color-code-recent" id="color-' + nodeJid + '">'+Icon+'</div>';
        $("[id='"+nodeJid+"']").find(".avatar-icon").html(imgDiv);
        $("[id='color-"+nodeJid+"']").css("background-color", imageRGB);
        $("[id='forwardcontact-"+nodeJid+"']").find(".forwardprofileicon").remove();
        let fwdImgDiv = '<div class="color-code-fwd" id="color-fwd-' + nodeJid + '"></div>';
        $("[id='forwardcontact-"+nodeJid+"']").find(".avatar-icon").html(fwdImgDiv);
        $("[id='color-fwd-"+nodeJid+"']").css("background-color", imageRGB);
        let toJID = utils.toJID();
        if (toJID != "" && nodeJid == stropheConnection.Strophe().getNodeFromJid(toJID)) {
          $(".color-code").html(Icon);
        }
      } else {

        // indexDb.blobImageConversion(profileImage,'#recentContactImg-'+nodeJid+'',nodeJid,'profileImages');
        $("[id='"+nodeJid+"']").find(".other-prof-pic").attr("src", profileImage);
        $("[id='forwardcontact-"+nodeJid+"']").find(".forwardprofileicon").attr("src", profileImage);
      }
    }
  },
  groupiqCallbackDataAppend(nodeJid,nickName,profileImage){
    if ($("[id='stared"+nodeJid+"']").length) {
      $("[id='stared"+nodeJid+"']").find(".userpersonal-name").html(minEmoji(nickName));
      $("[id='stared"+nodeJid+"']").find(".other-prof-pic").attr("src", profileImage);
    }
    let toJID = utils.toJID();
    if (toJID != "" && nodeJid == stropheConnection.Strophe().getNodeFromJid(toJID)) {

      $("#message").find(".heading-name-meta").html(minEmoji(nickName));
      $("#right-side-prof").attr("src", profileImage);
      $('#message .heading-avatar-icon div').first().attr('src','')
      $("#userprofile").find(".profile-inner").find("img").attr("src", profileImage);
      $(".groupname").html(minEmoji(nickName) + '<i class="groupNameEdit fa fa-pencil"></i>');
    }
              
    if ($("[id='forwardcontact"+nodeJid+"']").length) {
      $("[id='forwardcontact"+nodeJid+"']").find(".name-meta").html(minEmoji(nickName));
      $("[id='forwardcontact"+nodeJid+"']").find(".forwardprofileicon").attr("src", profileImage);
    }
  },
  groupIqGetTitle: function(count){
    let title;
    if(count == 0){
      title = "Ikonix Connect"
    }else {
      title = "(" + count + ") Ikonix Connect"
    }
    return title;
  },
  groupiqCallbacTitleUpdate(nodeJid){
    if ($("[id='"+nodeJid+"']").length) {
      if ($("[id='"+nodeJid+"']").find(".notify").text() != 0) {
        if (document.title != "Ikonix Connect") {
          let title;
          if (document.title.split("(").pop().split(")")[0] != 0) {
            let count = document.title.split("(").pop().split(")")[0] - 1;
            count = parseInt(count);
            title = module.exports.groupIqGetTitle(count)
          }
          document.title = title;
        }
      }
      $("[id='forwardcontact"+nodeJid+"']").remove();
    }
  },
  groupiqCallback: function (groupsiq) {
    try {
      if ($(groupsiq).find("group").length) {
        let groupProfile = module.exports.groupiqCallbackProfileGet()

        $(groupsiq).find("groupdetails").each(function (index) {
          let groupid = $(this).attr("groupid");
          let Createddate = $(this).attr("createddate");
          let nickName = $(this).find("nickName").text();

          let nodeJid = stropheConnection.Strophe().getNodeFromJid(groupid);
          groupProfile[nodeJid] = [];
          groupProfile[nodeJid].push("group");
          let image,icon,foregroundColor,locationId;

          let groupIQVal = $(this);
          let groupObj = module.exports.groupiqCallbackProfileUpdate(groupProfile,nodeJid,groupIQVal,Createddate)

          groupProfile     = groupObj.groupProfile;
          image            = groupObj.image;
          icon             = groupObj.icon;
          foregroundColor  = groupObj.foregroundColor;
          locationId       = groupObj.locationId;

          webEncrypt.encryptAndStoreInLocalStorage('groupProfile', groupProfile);
          

          let profileImage = module.exports.groupiqCallbackProfileImage(image);

          let iconObj = {
            icon: icon,
            foregroundColor: foregroundColor
          }
          module.exports.groupiqCallbackIconUpdate(nodeJid,nickName,locationId,image,iconObj,profileImage);

          module.exports.groupiqCallbackDataAppend(nodeJid,nickName,profileImage);
          
        });

        utils.forwardmsg();
      } else {

        let groupFrom = groupsiq.getAttribute("from");
        let nodeJid = stropheConnection.Strophe().getNodeFromJid(groupFrom);
        module.exports.groupiqCallbacTitleUpdate(nodeJid);
      }
    } catch (err) {
      console.log("groupiqCallback", err);
      console.log("groupiqCallback iq", groupsiq);
    }
    return true;
  },
  getgroupdetails: function (touser) {

    let groupdetailiq = stropheConnection.StropheJs().$iq({
      type: "get",
      to: touser,
      id: utils.randomString(16, "aA#")
    }).c("query", {
      xmlns: "jabber:iq:mixgroupchat",
      status: "get_participant"
    });
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().sendIQ(groupdetailiq, module.exports.groupdetailiqCallback);
    }
  },
  groupdetIqMemberDetail: function(){
    let groupMemberDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');
    
    if (groupMemberDetail == null) {
      groupMemberDetail = {};
    }

    return groupMemberDetail;
  },
  groupdetIqParticipantAppend(nodeJid,groupparticipant){
    if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
      $("#groupparticipant").html(groupparticipant);
    }
  },
  groupdetailiqCallback: function (groupiqdetail) {
    try {
   
    let userlist = "";
    let usersplit = "";
    let userIsAdmin = "";
    let loggedUserPresent = 0;
    let OldContact = "";
    let status,nickNameJID;
    let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
    let jid = groupiqdetail.getAttribute("from");
    let nodeJid = stropheConnection.Strophe().getNodeFromJid(jid);
    let groupProfile = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
    let groupInfo  = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
    let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
    let groupMemberDetail = module.exports.groupdetIqMemberDetail()
    let userToken = storage.getuserToken();

    groupMemberDetail[nodeJid] = {};

    if ($(groupiqdetail).find("participants").length) {
      let groupparticipant = '<div class="row compose-sideBar"><small></small><div class="row sideBar-body add-participant-link"><div class="add-people-icon">';
      groupparticipant = groupparticipant + '<i class="add-people"></i></div><div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name">';
      groupparticipant = groupparticipant + ' <div class="col-sm-12 col-xs-12 name-meta add-name "><a class="">' + language.locali().add_participants + '</a></div></div></div></div></div><div id="groupmemberslist-'+nodeJid+'"></div>';
      
      module.exports.groupdetIqParticipantAppend(nodeJid,groupparticipant)
      
      let usertext = 0;

      $(groupiqdetail).find("participants").find("participant").each(function () {
        let mediaUrl = window._env_.ApiURL + "/media/";
        let nickName = $(this).find("jid").text();
        let GroupUser = stropheConnection.Strophe().getNodeFromJid(nickName);
        let UserType = $(this).find("affiliation").text();
        let itemId = $(this).find("itemid").text();
        let affiliation = $(this).find("affiliation").text();

        let displayName = $(this).find("nickName").text();
        let userName = $(this).find("nickName").text();
        let image = $(this).find("image").text();
        status = $(this).find("status").text();
        let unregisteredUser = $(this).find("unregistered_user").text();
        let name = $(this).find("nickName").text();
        

        let userJID = stropheConnection.logininfo.userJID;
        if (toJID != null) {
          nickNameJID = stropheConnection.Strophe().getNodeFromJid(nickName);
          let imageExtArray = ['jpg','jpeg','png','webp'];
          let profileExtention = image.split('.').pop();

          $("[id='forwardcontact-"+nickNameJID+"']").css('display', 'none');
          if (nickNameJID != userJID && nickNameJID != storage.adminName()) {
            userlist = userlist + usersplit + utils.toTitleCase(displayName);
            usersplit = ", ";
            if (unregisteredUser != 1) {
              if (image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== '') {
                image = mediaUrl + image + "?mf=" + userToken;
              } else if (image.trim() == '') {
                image = "src/images/avatar/chat/profile_img_one.svg";
              }
            } else {
              image = "src/images/avatar/chat/profile_img_one.svg"; 
            }
            
            let admintext,dropdowntext,participantDiv,imageDiv,nameDiv,statusDiv;
            if (affiliation == 'o') {
              admintext = '<span class="grp-admin"><span class = "grp-admin-user">' + language.locali().group_admin + '</span></span>';
              dropdowntext = '<div class="dropdown contact-opt groupadmin"><a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown"><i class="option-arrow"></i></a><ul class="dropdown-menu contact-menu" role="menu" aria-labelledby="menu1">';
              dropdowntext = dropdowntext + '</ul></div>';
            } else {

              admintext = '<span class="grp-admin"></span>';
              dropdowntext = '<div class="dropdown contact-opt groupmember"><a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown"><i class="option-arrow"></i></a><ul class="dropdown-menu contact-menu" role="menu" aria-labelledby="menu1">';
              dropdowntext = dropdowntext + '</ul></div>';
            }

            let concatedLetter,
            imageElment;

            if(name != "") {
               
                concatedLetter = utils.getImageDisplayText(name);
            }
            let imageFavIconClass = '';

            if(image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== ''){
              if(imageExtArray.includes(profileExtention)){
                indexDb.blobImageConversion(image,'#groupParticipantList-'+nickNameJID+'',nickNameJID,'profileImages');
                imageElment ='<img id="groupParticipantList-'+nickNameJID+'" src="' + image + '" onerror="' + contact.profileImgError() + '" />';
                imageFavIconClass = 'avatar-icon-height';

              }else {
                imageElment = '<svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg>';
              }
            }  else {
                imageElment = '<svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg>';
            }

            let groupUserNameClass,groupUserStatusClass;
            if (affiliation == 'o') {
              groupUserNameClass='group_user_name_high';
              groupUserStatusClass = 'group_user_status_high';
            }else {
              groupUserNameClass='group_user_name_low';
              groupUserStatusClass = 'group_user_status_low';
            }


            participantDiv = '<div class="row sideBar-body groupmembers"  id="member-' + nickNameJID + '"><div class="col-sm-3 col-xs-3 sideBar-avatar">';
            
            nameDiv = '<div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name"><div class="col-sm-12 col-xs-12 sideBar-name"><span class="name-meta contactname groupinfo-name '+groupUserNameClass+'">' + minEmoji(displayName) + '</span>' + admintext ;

            let statusEl;
            if (unregisteredUser == 1) {
              statusEl = '';
            imageDiv = '<div class="avatar-icon groupparticiroupmemberspantcontent '+imageFavIconClass+'">'+imageElment+'</div> </div>';

            }else {

              statusEl = '<span class="name-status  '+groupUserStatusClass+'" style="color:'+utils.getStatusImage(status)+'">' + minEmoji(utils.getStatusName(status)) + ' </span>';
            imageDiv = '<div class="avatar-icon groupparticiroupmemberspantcontent '+imageFavIconClass+'">'+imageElment+'<img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg"></div> </div>';

            }

            statusDiv = '<div class="sideBar-msg">' +statusEl+ dropdowntext + '</div></div></div></div></div>';
           
            OldContact += participantDiv + imageDiv + nameDiv + statusDiv;

          } else if (nickNameJID == userJID) {
            loggedUserPresent = 1;
            if (affiliation == 'o') {
              usertext = '<span class="grp-admin"><span class = "grp-admin-user">' + language.locali().group_admin + '</span></span>';
              userIsAdmin = 1;
            } else if (affiliation == 'n') {
              usertext = 1;
              userIsAdmin = 0;
            }
          }
          if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
            $("#groupmemberslist-"+nodeJid+"").html(OldContact);
          }
          if (usertext != 0) {
            $('#comment').prop('disabled', false);
            $('.heading-attach').show();
            $('.reply-recording').show();
            $('.emojiPickerIconWrap').show();
            $("#message .heading-dot").show();

            displayName = 'You';
            if (usertext != 1) {
              $(".groupadmin ul").append('<li role="presentation"><a  class="remove-grp-cnt-link" >' + language.locali().remove + '</a></li>');
              $(".groupmember ul").append('<li role="presentation"><a  class="remove-grp-cnt-link" >' + language.locali().remove + '</a></li><li role="presentation"><a   href="javascript:void(0);" class="make-grp-admin-link">' + language.locali().make_group_admin + '</a></li>');
            } else {
              usertext = "<span></span>";
              $(".groupadmin").html('');
              $(".groupmember").html('');
              $(".add-participant-link").hide();
            }
            $('.heading-online').css('display', 'block');

            let ProfileImage = myInfo[userJID][2];

            if (utils.getHexRegexPattern().test(ProfileImage)) {
              ProfileImage = myInfo[userJID][2];
            } else if (ProfileImage !== 'src/images/avatar/chat/profile_img_one.svg' && ProfileImage.trim() !== '') {
              ProfileImage = mediaUrl + ProfileImage + "?mf=" + userToken;
              indexDb.blobImageConversion(ProfileImage,'#groupParticipantListAdmin-'+nickNameJID+'',nickNameJID,'profileImages');

            } else if (ProfileImage == '') {
              ProfileImage = "src/images/avatar/chat/profile_img_one.svg";
            } else {
              ProfileImage = myInfo[userJID][2];
            }
            status = myInfo[userJID][3];
            let participantDiv,imageDiv,nameDiv,statusDiv;

            let concatedLetter;
            let myInfoName = myInfo[userJID][1];
            if(myInfoName != "") {
               
                concatedLetter = utils.getImageDisplayText(myInfoName);
            }

            if(ProfileImage == "src/images/avatar/chat/profile_img_one.svg"){
              imageDiv = '<div class="avatar-icon groupparticiroupmemberspantcontent"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg><img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg"></div></div>';

            }else {
              imageDiv = '<div class="avatar-icon groupparticiroupmemberspantcontent avatar-icon-height"><img id="groupParticipantListAdmin-'+nickNameJID+'" src="' + ProfileImage + '"><img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg"></div> </div>';

            }

            participantDiv = '<div class="row sideBar-body groupmembers"><div class="col-sm-3 col-xs-3 sideBar-avatar">';
            nameDiv = '<div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name"><div class="col-sm-12 col-xs-12 sideBar-name"><span class="name-meta">' + minEmoji(displayName) + '</span>' + usertext;
            statusDiv = '<div class="sideBar-msg"><span class="name-status" style="color:'+utils.getStatusImage(status)+'">' + minEmoji(utils.getStatusName(status)) + ' </span></div></div></div></div></div>';
            if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
                $("#groupmemberslist-"+nodeJid+"").append(participantDiv + imageDiv + nameDiv + statusDiv);
            }
          } else {
            $('#comment').prop('disabled', true);
            if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
              $('.exit-chat').css('display', 'none');
              $('.exit-group-link').hide();
              $('.reply-recording').hide();
              $('.heading-attach').hide();
             }
            $('.emojiPickerIconWrap').hide();
            $(".groupadmin").html('');
            $(".groupmember").html('');
            $('.contact-exit').find('a').html('');
            $('.heading-online').css('display', 'block');
          }
        }
        if (GroupUser != null && GroupUser != storage.adminName()) {
          groupMemberDetail[nodeJid][itemId] = {};
          groupMemberDetail[nodeJid][itemId].user = GroupUser;
          groupMemberDetail[nodeJid][itemId].type = UserType;
          groupMemberDetail[nodeJid][itemId].displayName = userName;
          groupMemberDetail[nodeJid][itemId].image = image;
          groupMemberDetail[nodeJid][itemId].status = status;
          webEncrypt.encryptAndStoreInLocalStorage('groupDetails', groupMemberDetail);
        }
      });
      if (loggedUserPresent == 1) {
        $(".recentchatcontact").find("[id='forwardcontact"+nodeJid+"']").remove();
        $("[id='"+nodeJid+"']").find(".exitclass").find(".exit-group-delete").html("Delete Team");
      }

      if (userIsAdmin == 0) {
        $(".groupadmin").html('');
        $(".groupmember").html('');
        $('.contact-exit').find('a').html('');
      }

      let groupMembersCount = _.size(groupMemberDetail[nodeJid]);
      let non_chatuser_participants = $(groupiqdetail).find("non_chatuser_participants").find("participant").length;
      if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
      
        $('#groupparticipant').find('small').html(language.locali().participants + " <i>" + parseInt(groupMembersCount + non_chatuser_participants) + "</i>");
      }

      let memberExist = true;
      let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');

      let userJID = stropheConnection.logininfo.userJID;
      let groupmember;
      if (groupDetail != null && typeof groupDetail[nodeJid] != "undefined") {
        groupmember = groupDetail[nodeJid];
        for (let keys in groupmember) {
          let values = groupmember[keys];
          let nickNameJID = values.user;
          if (nickNameJID == userJID) {
            memberExist = false;
          }
        }
        if (memberExist) {
          $(".recentchatcontact").find("[id='forwardcontact"+nodeJid+"']").remove();
          $("[id='"+nodeJid+"']").find(".exitclass").remove();
        }
      }

      $(groupiqdetail).find("non_chatuser_participants").find("participant").each(function () {

        let mediaUrl = window._env_.ApiURL + "/media/";
        if($(this).find('user_id').length != 0){

         let nickName = $(this).find("jid").text();
         let GroupUser = stropheConnection.Strophe().getNodeFromJid(nickName);
         let UserType = $(this).find("affiliation").text();
         let itemId = $(this).find("itemid").text();
         let userName = $(this).find("nickName").text();
         let status = $(this).find("status").text();
         let affiliation = $(this).find("affiliation").text();

        
          let user_id = $(this).find("user_id").text();
          let displayName = $(this).find("given_name").html();
          let preferredDevice = $(this).find("preferred_device").html();
          let name = $(this).find("given_name").html();
          
          if(userlist != "")
            userlist = userlist + ", " + utils.toTitleCase(displayName);
          else
            userlist = utils.toTitleCase(displayName);

          let image = $(this).find("image").text();
          if (image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== '') {
            image = mediaUrl + image + "?mf=" + userToken;
          } else if (image.trim() == '') {
            image = "src/images/avatar/chat/profile_img_one.svg";
          }

          let concatedLetter,
              imageElment;

              if(name != "") {
                  concatedLetter = utils.getImageDisplayText(name);
              }
              let imageFavIconClass = '';

              if(image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== ''){
                  indexDb.blobImageConversion(image,'#groupParticipantListImg-'+nickNameJID+'',nickNameJID,'profileImages');

                  imageElment ='<img id="groupParticipantListImg-'+nickNameJID+'" src="' + image + '" onerror="' + contact.profileImgError() + '" />';
                  imageFavIconClass = 'avatar-icon-height';
              }  else {
                  imageElment = '<svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg>';
              }
            let groupUserNameClass,groupUserStatusClass;
            if (affiliation == 'o') {
              groupUserNameClass='group_user_name_high';
              groupUserStatusClass = 'group_user_status_high';
            }else {
              groupUserNameClass='group_user_name_low';
              groupUserStatusClass = 'group_user_status_low';
            }

          let participantDivs = '<div class="row sideBar-body groupmembers"  id="member-' + user_id + '"><div class="col-sm-3 col-xs-3 sideBar-avatar">';
          let imageDivs = '<div class="avatar-icon groupparticiroupmemberspantcontent '+imageFavIconClass+'">'+imageElment+'</div> </div>';
          let nameDivs = '<div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name"><div class="col-sm-12 col-xs-12 sideBar-name"><span class="name-meta contactname groupinfo-name '+groupUserNameClass+'">' + minEmoji(displayName) + '</span>';
          let PreferredDeviceDivs = '<div class="sideBar-msg"><span class="name-status '+groupUserStatusClass+'">Contact user via ' + preferredDevice + ' </span></div>';
          let OldContacts = participantDivs + imageDivs + nameDivs + PreferredDeviceDivs + '</div></div></div></div></div>';
          if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
            $("#groupmemberslist-"+nodeJid+"").append(OldContacts);
          }
          if(typeof(groupInfo[nodeJid][4]) != 'undefined') {

            if (GroupUser != null && GroupUser != storage.adminName()) {
              groupMemberDetail[nodeJid][itemId] = {};
              groupMemberDetail[nodeJid][itemId].user = GroupUser;
              groupMemberDetail[nodeJid][itemId].type = UserType;
              groupMemberDetail[nodeJid][itemId].displayName = userName;
              groupMemberDetail[nodeJid][itemId].image = image;
              groupMemberDetail[nodeJid][itemId].status = status;
              webEncrypt.encryptAndStoreInLocalStorage('groupDetails', groupMemberDetail);

            }
          }
        }
        
      })
    } else {
      if ($("[id='forwardcontact"+nodeJid+"']").length) {
        $("[id='forwardcontact"+nodeJid+"']").remove();
      }
      if ($("[id='"+nodeJid+"']").length) {
        $("[id='"+nodeJid+"']").find(".exitclass").find(".exit-group-delete").html("Delete Team");
      }
      webEncrypt.encryptAndStoreInLocalStorage('groupDetails', groupMemberDetail);

      $("#comment").prop("disabled", true);
    }
    if (nodeJid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
      let image = groupProfile[nodeJid][2];
      if (utils.getHexRegexPattern().test(image)) {
        image = groupProfile[nodeJid][2];
      } else if (image !== 'src/images/avatar/group/group_four.svg' && image.trim() !== '') {
        image = mediaUrl + image + "?mf=" + userToken;
      } else if (image.trim() == '') {
        image = "src/images/avatar/group/group_four.svg";
      }

      if (utils.getHexRegexPattern().test(image)) {
        $("img.right-side-prof").css("display", "none");
        $(".color-code").css("display", "block");
        colorCode = utils.hexToRgbA(image);
        $('.color-code').css('background-color', colorCode);
      } else {
        $("img.right-side-prof").css("display", "block");
        $(".color-code").css("display", "none");
        $(".user_profile-image").attr("src", image);
      }
      /** Check Current User Exist Or Not**/
      let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');

      let grpUsers = [];
      let userJID = stropheConnection.logininfo.userJID;
       grpUsers = grpConversation.updateuserprofGetGrpUser(grpUsers,groupDetail,nodeJid)
      let grpMem = grpConversation.updateuserprofGetGrpMem(grpUsers,userJID)
      if(grpMem){
        if(grpUsers.length > 1){
          $('.heading-online').html(userlist + ", You");
        }else {
          $('.heading-online').html("You");
        }
        $('.row.reply').css('display', 'flex');
        $(".blocked-person").css("display", "none");
      }else {
        $('.heading-online').html(userlist);
      }
      $('.invitation_div').hide();

      let rightSideHeaderId = $("#rightSideHeaderId").val();
      if(rightSideHeaderId == nodeJid){

        grpConversation.updateuserprofile(nodeJid);
      }
    }
  } catch (error) {
      console.log("Group detail iq Callback Error: ", error)
  }
    return true;
  },
  addMember: function (userid, msgToName) {
    let myJid = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
    let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
    let addGroupMember = stropheConnection.StropheJs().$iq({ type: "set", id: utils.getId(), to: utils.toJID() }).c("query", {
      status: "add_participants",
      xmlns: "jabber:iq:mixgroupchat"
    }).c("subscriptions", {}).c("subscribe", { node: "urn:xmpp:mix:nodes:messages" }).up().c("subscribe", { node: "urn:xmpp:mix:nodes:presence" }).up().c("subscribe", { node: "urn:xmpp:mix:nodes:participants" }).up().c("subscribe", { node: "urn:xmpp:mix:nodes:subject" }).up().c("subscribe", { node: "urn:xmpp:mix:nodes:config" }).up().up().c("participants", {}).c("participant", {
      message_from: myInfo[myJid][1],
      message_to: msgToName
    }).t(userid).up();
    $("input:checkbox.select-message3").prop("checked", false).change();
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().send(addGroupMember);
    }
  },
  removemember: function (userid, username) {
    let myJid = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
    let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
    let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');

    let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
    let groupmember = groupDetail[stropheConnection.Strophe().getNodeFromJid(tojid)];
    for (let key in groupmember) {
      let values = groupmember[key];
      let itemvalue = values.user;
      let itemtype = values.type;
      let statusIQ;
      if (itemvalue == stropheConnection.Strophe().getNodeFromJid(userid)) {
        if (itemtype == "a" || itemtype == "n") {
          statusIQ = "admin_remove_participant";
        } else {
          statusIQ = "admin_remove_admin";
        }
        let removeMember = stropheConnection.StropheJs().$iq({ type: "set", id: utils.getId(), to: tojid }).c("query", {
          xmlns: "jabber:iq:mixgroupchat",
          status: statusIQ
        }).c("participant", {
          message_from: myInfo[myJid][1],
          message_to: username
        }).t(userid).up();
        webEncrypt.deleteItemFromLocalStorage('adminUserInfo');
        if (stropheConnection.Connection().connected) {
          stropheConnection.Connection().sendIQ(removeMember, module.exports.getremoveMemberCallBack);
        }
      }
    }
  },
  getremoveMemberCallBack: function (removememberiq) {
    return true;
  },
 
  userexit: function (userid, checkType) {
    let myJid = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
    let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
    let groupid;
    if (tojid != null) {
      groupid = stropheConnection.Strophe().getNodeFromJid(tojid);
    }
    let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
    if (groupInfo != null && typeof groupInfo[userid] != "undefined" && groupInfo[userid][0] == "group") {
      tojid = userid + "@mix." + stropheConnection.Server();
      groupid = userid;
      userid = stropheConnection.logininfo.userJID;
    }

    if (checkType == "deletegroup") {
      let isMemberExit;
      isMemberExit = module.exports.checkLogedUserExistInGrop(groupid);
      let isExitAndDel = $("#isExitAndDel").val()

      if(isMemberExit && isExitAndDel != 1){
        $("#isExitAndDel").val(0)
        $("#infoContent").text(language.locali().current_member_alert);
        $('#infobox').css("display", "block").delay(6000).fadeOut();
      }else {
        $("#isExitAndDel").val(0)
        module.exports.exitUserGroupCallBack(tojid,myJid,groupid,userid);
        module.exports.deleteUserGroupCallBack(tojid);
      }
    } else {
      $("#isExitAndDel").val(0);
      module.exports.exitUserGroupCallBack(tojid,myJid,groupid,userid);
    }
  },
  /** Check Logged User Available in Group **/
  checkLogedUserExistInGrop(groupId){
    let memberExist = false;
    let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');

    let userJID = stropheConnection.logininfo.userJID;
    let groupmember;
    if (groupDetail != null && typeof groupDetail[groupId] != "undefined") {
      groupmember = groupDetail[groupId];
      for (let keys in groupmember) {
        let values = groupmember[keys];
        let nickNameJID = values.user;
        if (nickNameJID == userJID) {
          memberExist = true;
        }
      }
      return memberExist;
    }
  },
  deleteUserGroupCallBack: function(tojid){
    let userExit = stropheConnection.StropheJs().$iq({ type: "set", id: utils.getId(), to: tojid }).c("query", {
      xmlns: "jabber:iq:mixgroupchat",
      status: "user_delete_group"
    });
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().sendIQ(userExit, module.exports.getuserExitCallBack);
      $(".side-frd-profile").css({
        "right": "-100%"
      });
    }
  },
  exitUserGroupCallBack: function(tojid,myJid,groupid,userid){
    let nodeJid,groupmember,statusIQ,userExit;
    let itemtype = "";
    let exituser = userid + "@" + stropheConnection.Server();
    let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
    let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');


    if (userid == stropheConnection.logininfo.userJID) {
      nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
      $(".recentchatcontact").find("[id='forwardcontact-"+nodeJid+"']").remove();
    }
    if (groupDetail != null && typeof groupDetail[groupid] != "undefined") {
      groupmember = groupDetail[groupid];
      for (let key in groupmember) {
        let value = groupmember[key];
        let itemvalue = value.user;
        if (itemvalue == userid) {
          itemtype = value.type;
        }
      }
      if (itemtype == "n") {
        statusIQ = "user_exit_group";
      } else {
        statusIQ = "admin_exit_group";
      }
      userExit = stropheConnection.StropheJs().$iq({ type: "set", id: utils.getId(), to: tojid }).c("query", {
        xmlns: "jabber:iq:mixgroupchat",
        status: statusIQ
      }).c("participant", {
        message_from: myInfo[myJid][1],
        message_to: myInfo[myJid][1]
      }).t(exituser).up();
      if (stropheConnection.Connection().connected) {
        stropheConnection.Connection().sendIQ(userExit, module.exports.getuserExitCallBack);
      }
    } else {
      module.exports.getgroupdetails(tojid);
      setTimeout(function () {
        module.exports.userexit(userid, "");
      }, 2000);
    }
  },
  getuserExitCallBack: function (removememberiq) {
    try {
      let jid = removememberiq.getAttribute("from");
      module.exports.getgroupdetails(jid);
    } catch (err) {
      console.log("getuserExitCallBack", err);
      console.log("getuserExitCallBack iq", removememberiq);
    }
    return true;
  },
  makeadmin: function (userid, username) {
    let myJid = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
    let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
    let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
    let makeAdmin = stropheConnection.StropheJs().$iq({ type: "set", id: utils.getId(), to: tojid }).c("query", {
      xmlns: "jabber:iq:mixgroupchat",
      status: "make_admin"
    }).c("participant", {
      message_from: myInfo[myJid][1],
      message_to: username  
    }).t(userid).up();
    if (stropheConnection.Connection().connected) {
      stropheConnection.Connection().sendIQ(makeAdmin, module.exports.getmakeAdminCallBack);
    }
  },
  getmakeAdminCallBack: function (makeadminiq) {
    return true;
  },
  profileImgError: function() {
    $('img').on("error", function () {
      this.onerror = "";
      this.src = "./src/images/avatar/chat/profile_img_one.svg";
    });
  }
};
